<template>
    <div class="main">
        <div class="sky">
            <img class="clound pos" src="../assets/img/clound.png" alt="">
            <img class="sun pos" src="../assets/img/sun.png" alt="">
        </div>
        <div class="title pos">
            <img src="http://wwj.jijiagames.com/web/act/20190702/title.png" alt="">
        </div>
        <div class="num-box pos">
            <p>已有 <span>{{num}}</span> 人通过测试</p>
        </div>
        <div class="small-clound">

        </div>
        <div class="rabbit pos">
            <img class="rabbit-img"  src="http://wwj.jijiagames.com/web/act/20190702/rabbit.png" alt="">
            <div>
                <img :style="testStyle(idx)" v-for="(item,idx) in 5" :key="idx"  class="han-left pos" src="../assets/img/han_left.png" alt="">
            </div>
           <div>
                <img :style="testStyle(index)" v-for="(item,index) in 5" :key="index" class="han-right pos" src="../assets/img/han_right.png" alt="">
           </div>
        </div>
        <img class="leaf2 pos" src="http://wwj.jijiagames.com/web/act/20190702/leaf2.png" alt="">
        <img class="leaf pos" src="../assets/img/leaf.png" alt="">
        <img class="leaf3 pos" src="../assets/img/leaf3.png" alt="">
        <img class="hua pos animationUpDown" src="../assets/img/hua.png" alt="">
        <img class="hua2 pos" src="../assets/img/hua2.png" alt="">
        <img class="hua3 pos" src="../assets/img/hua3.png" alt="">
        <img class="dong pos" src="../assets/img/dong.png" alt="">
        <div class="start-btn pos" @click="toTest" v-if="loadFlag">
            <img src="../assets/img/start_btn.png" alt="">
        </div>
        <p class="txt pos">夏日必备太阳伞、冰垫、尽在韵文博鉴淘宝店，做完测试有机会免费拿哦！</p>
    </div>
</template>

<script>
function loadImg(url) {
    return new Promise(res => {
        const img = new Image();
        img.src = url;
        img.onload = () => {
            res();
        };
        img.onerror = () => {
            res();
        };
    });
}
function loadVideo(video) {
    return new Promise(res => {
        video.addEventListener('canplay', () => {
            res();
        }, false);
        setTimeout(() => {
            res();
        }, 2000);
    });
}
function loadAudioQueue() {
    const audios = document.getElementsByClassName('bg-music');
    console.log(audios);
    return Promise.all(Array.from(audios).map(item => loadVideo(item)));
}

export default {
    data() {
        return {
            num: 0,
            loadFlag: false
        };
    },
    mounted() {
        this.testNum();
        const imgs = [
            require('../assets/img/share_air.jpg'),
            require('../assets/img/share_bing.jpg'),
            require('../assets/img/share_hot.jpg'),
            require('../assets/img/share_san.jpg'),
            require('../assets/img/result_air.jpg'),
            require('../assets/img/result_bing.jpg'),
            require('../assets/img/result_hot.jpg'),
            require('../assets/img/result_san.jpg'),
            require('../assets/img/third_tree.png'),
            require('../assets/img/test_bg.jpg'),
            require('../assets/img/bg.jpg'),
            require('../assets/img/rabbit.png'),
            require('../assets/img/box_bg.png'),
            require('../assets/img/end_box.png'),
            require('../assets/img/small_tree.png'),
            require('../assets/img/fifth_tree.png'),
            require('../assets/img/second_smallTree.png'),
            require('../assets/img/fifth_yellow.png'),
            require('../assets/img/clothing.png'),
            require('../assets/img/tree.png'),
            require('../assets/img/yellow_hua.png'),
            require('../assets/img/second_redhua.png'),
            require('../assets/img/hot.png'),
            require('../assets/img/san.png'),
            require('../assets/img/bing.png'),
            require('../assets/img/air.png')
        ].map(v => loadImg(v));
        Promise.all([
            ...imgs,
            loadAudioQueue()
        ]).then(() => {
            this.loadFlag = true;
        }).catch(e => {
        });
    },
    methods: {
        testStyle(index) {
            return {
                animationDelay: `${index / 2 + 0.8}s`
            };
        },
        toTest() {
            this.$emit('next', 2);
        },
        testNum() {
            const oldTime = new Date('2019/7/2').getTime();
            const currentTime = new Date().getTime();
            this.num = ((currentTime - oldTime) / 1000 / 60).toFixed(0) - 600;
            setInterval(() => {
                this.num++;
            }, 60000);
        }
    }
};
</script>

<style lang="stylus" scoped>
.main
    position relative
    width 100%
    height 100%
    background url("../assets/img/bg.jpg") 0 0/100% 100% no-repeat
    .sky
        position relative
        height 3.34rem
        .clound
            top 0.15rem
            left 0
            width 100%
            z-index 22
        .sun
            top 0.22rem
            left 0.95rem
            width 1.91rem
            height 1.97rem
            animation rotate 4s linear infinite
    .title
        z-index 666
        width 100%
        top 16%
        text-align center
        img
            width 70%
    .num-box
        width 100%
        display flex
        justify-content center
        top 36%
        font-size 0.34rem
        span
            color #f66
    .rabbit
        width 100%
        text-align center
        bottom 10%
        left 50%
        transform translateX(-50%)
        .rabbit-img
            width 60%
        .han-left
            top 1.8rem
            left 3.0rem
            z-index 666
            &:nth-of-type(2)
                transform translateX(-0.2rem) translateY(0.5rem)
            &:nth-of-type(3)
                transform translateX(-0.4rem) translateY(0.9rem)
            &:nth-of-type(4)
                transform translateX(-0.6rem) translateY(1.4rem)
            &:nth-of-type(5)
                transform translateX(-0.8rem) translateY(1.9rem)
            &:nth-of-type(6)
                transform translateX(-1rem) translateY(2.4rem)
            opacity 0
            animation show 2s infinite
            animation-fill-mode forwards
        .han-right
            top 1.8rem
            right 3rem
            z-index 666
            &:nth-of-type(2)
                transform translateX(0.2rem) translateY(0.5rem)
            &:nth-of-type(3)
                transform translateX(0.4rem) translateY(0.9rem)
            &:nth-of-type(4)
                transform translateX(0.6rem) translateY(1.4rem)
            &:nth-of-type(5)
                transform translateX(0.8rem) translateY(1.9rem)
            &:nth-of-type(6)
                transform translateX(1rem) translateY(2.4rem)
            opacity 0
            animation show 2s infinite
            animation-fill-mode forwards
    .leaf2
        bottom 0
        z-index 11
    .leaf
        bottom 0
        right 0
        z-index 13
    .leaf3
        bottom 1.9rem
    .hua
        bottom 0.8rem
        right 0
        z-index 13
    .hua2
        bottom 0
        left 14%
        z-index 13
    .hua3
        bottom 4.5rem
        left -0.3rem
        z-index 13
        animation up 1.2s ease-out infinite
    .dong
        bottom 0
        left 0.3rem
        z-index 13
        animation up 1.2s ease-out infinite
    .start-btn
        bottom 0.7rem
        left 50%
        transform translateX(-50%)
        z-index 666
    .txt
        width 100%
        bottom 0.1rem
        font-size 0.2rem
        color rgb(27,84,102)
        text-align center
        z-index 999
.pos
    position absolute
@keyframes rotate
    0%
        transform rotate(0deg)
    25%
        transform rotate(90deg)
    50%
        transform rotate(180deg)
    75%
        transform rotate(270deg)
    100%
        transform rotate(360deg)
@keyframes up
    0%
        transform translateY(0)
    30%
        transform translateY(5px)
    50%
        transform translateY(0px)
    80%
        transform translateY(-5px)
    100%
        transform translateY(0)
@keyframes show
    0%
        filter blur(12px)
        opacity 0
    100%
        filter blur(0)
        opacity 1
</style>
